export class DokumentUrlDTO {
    url?: string;
    meddelande?: string;
}
